import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  employees: [],
  error: null,
  message: '',
};
const AttendanceRegisterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ATTENDANCE_REQUEST:
    case actionTypes.UPDATE_ATTENDANCE_REQUEST:
    case actionTypes.DELETE_ATTENDANCE_REQUEST:
    case actionTypes.MULTIDELETE_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_ATTENDANCE_SUCCESS:
    case actionTypes.MULTIDELETE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: action.payload,
      };
    case actionTypes.GET_ATTENDANCE_SUCCESS:
    case actionTypes.DELETE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: action.payload,

      }

    case actionTypes.GET_ATTENDANCE_FAILURE:
    case actionTypes.UPDATE_ATTENDANCE_FAILURE:
    case actionTypes.DELETE_ATTENDANCE_FAILURE:
    case actionTypes.MULTIDELETE_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AttendanceRegisterReducer
